<template>
  <div class="footer_box">
    {{ time }}
  </div>
</template>

<script>
export default {
  name: 'FooterCommon',
  props: {
    mtime: {
      type: Date,
      default: ''
    }
  },
  data() {
    return {
      time: '', // 显示的格式化时间
      timer: null, // 定时器实例
      baseTime: null // 基准时间（存储mtime解析后的时间或当前时间）
    }
  },
  methods: {
    updateTime() {
      let now;
      if (this.baseTime) {
        // 有基准时间时：基于基准时间每秒+1秒（定时器1秒执行一次）
        this.baseTime.setSeconds(this.baseTime.getSeconds() + 1);
        now = new Date(this.baseTime);
      } else {
        // 无基准时间时：使用当前系统时间
        now = new Date();
      }
      // 格式化时间（保持原有格式）
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const seconds = String(now.getSeconds()).padStart(2, '0');
      this.time = `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
    }
  },
  watch: {
    // 监听mtime变化（包括初始化时）
    mtime: {
      immediate: true, // 组件初始化时立即执行一次
      handler(newVal) {
        // 第一步：清理原有定时器，避免多个定时器同时运行
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }

        // 第二步：处理传入的mtime，设置基准时间
        if (newVal) {
          // 解析mtime为Date对象（支持常见格式：2026-02-03 12:00:00、时间戳等）
          this.baseTime = new Date(newVal);
          // 校验时间格式是否有效
          if (isNaN(this.baseTime.getTime())) {
            console.warn('mtime格式错误，将使用当前时间', newVal);
            this.baseTime = new Date();
          }
        } else {
          // mtime为空时，基准时间设为当前时间
          this.baseTime = new Date();
        }

        // 第三步：立即更新一次时间，并重启定时器
        this.updateTime();
        this.timer = setInterval(this.updateTime, 1000);
      }
    }
  },
  // 组件销毁前清理定时器，防止内存泄漏
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
</script>

<style scoped>
.footer_box {
  width: 100%;
  height: 100%;
  background-color: var(--color-primary-dark-2);
  border-radius: 0.1rem;
  font-size: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 0.3rem;
  box-sizing: border-box;
  color: #fff;
}
</style>